import React, { useState, useContext } from 'react';
import Flag from 'react-flags';
import RadioConfigContext from '../../context/RadioConfigContext/RadioConfigContext';
import { availableCountries, Country, ICategory } from '../../api';
import { ChooseCoutryBox, ChooserBox, HeaderBox, SingleCountry, CountryName, ChooserBody, FlagBox } from './ChooseCountry.css';
import { FilterInput } from '../CategoryChooser/CategoryChooser.css';

export const sFn = (a: Country | ICategory, b: Country | ICategory): number => {
  const  nameA = a.name.toLowerCase();
  const nameB = b.name.toLowerCase();
  if (nameA < nameB)
    return -1
  if (nameA > nameB)
     return 1
  return 0;
}

const ChooseCountry = (props: { setShowFavs: (showFavs: boolean) => void }) => {
  const [chooserOpened, setChooserOpened] = useState(false);
  const [filterValue, setFilterValue] = useState('');
  const [filteredCategories, setFilteredCategories] = useState(availableCountries.sort(sFn));
  const { radioConfig, setRadioConfig } = useContext(RadioConfigContext);

  const handleChangeCountry = (country: string) => {
    props.setShowFavs(false);
    setRadioConfig({...radioConfig, lang: country, currentCategory: 0});
    setChooserOpened(false);
  };

  const handleFilterCategories = (e: any) => {
    const val = e.target.value as string;
    console.log(val);
    setFilterValue(val);
    if (val.length > 0) {
      setFilteredCategories([...availableCountries.filter( x => x.name.toLowerCase().indexOf(val.toLowerCase()) > -1 )])
    } else {
      setFilteredCategories(availableCountries);
    }
  }

  return (
    <ChooseCoutryBox>
      <FlagBox onClick={() => setChooserOpened(true)}>
        <Flag
          basePath="images"
          name={radioConfig.lang}
          format="png"
          pngSize={24}
          shiny={true}
          alt=""
        />
      </FlagBox>
      <ChooserBox open={chooserOpened}>
        <HeaderBox onClick={() => setChooserOpened(false)}>CHOOSE COUNTRY <i className="fa fa-window-close" /></HeaderBox>
        <FilterInput placeholder="Search country" type="text" value={filterValue} onChange={handleFilterCategories} />
        <ChooserBody>
          {filteredCategories.map((country) => <SingleCountry onClick={() => handleChangeCountry(country.code)} active={radioConfig.lang===country.code}>
            <Flag
              basePath="images"
              name={country.code}
              format="png"
              pngSize={24}
              shiny={true}
              alt=""
            />
            <CountryName active={radioConfig.lang===country.code}>{country.name}</CountryName>
          </SingleCountry>
          )}
        </ChooserBody>
      </ChooserBox>
    </ChooseCoutryBox>
  );
};

export default ChooseCountry;